{
    "AgentDetails_GUID": "Identifier (GUID):",
    "AgentNumber": "Agent Number:",
    "AgentDetails_Partition": "Partition:",
    "AgentDetails_Description": "Description:",
    "AgentDetails_UpdateExistingItems": "Update Duplicate Items:",

    "AgentDetails_GUIDPlaceholder": "[Auto Assigned]",

    "AgentDetails_Validation_GUID": "Max length of a GUID is 100 characters",
    "AgentDetails_Validation_AgentNumber": "An agent number must be provided",
    "AgentDetails_Validation_Partition": "A partition must be selected",

    "AgentDetails_NonePartition": "[None]",

    "NAME": "AgentDetails"
}